import styled from 'styled-components'

/** 에러 메시지 텍스트 */
export const WarningMsg = styled.span.attrs({
  className: 'error',
})`
  font-size: var(--s-caption);
  font-family: var(--f-caption);
  line-height: var(--l-caption);
  display: block;
  width: 100%;
  text-align: left;
  color: var(--c-blue);
  padding-top: ${props => props.$padT || '0'};
  padding-left: ${props => props.$padL || '0'};
`
